import {DescriptionText, H1Text, H2Text} from "../../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../../helper";
import SmallScreenHeader from "../../../../../components/smallscreen/header";
import currencyformatter from "../../../../../utils/currencyformatter";

type Props = {
  account: Object,
  payment: Object,
  whiteLabel: Boolean,
  bankImageUrl: String,
  eventDetails: Object,
  selectedSeats: Array<Object>,
}

const Header = (props:Props) => {
  const { account, payment, bankImageUrl, whiteLabel, eventDetails, selectedSeats } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  return (
    <SmallScreenHeader paymentCheckout={true} bankImageUrl={bankImageUrl} largeLogo={largeLogo} whiteLabel={whiteLabel}>
      <H1Text>
        Payment Checkout
      </H1Text>
      <H2Text>
        Payment For { payment?.account && <p>{payment?.account.name}</p> }
      </H2Text>
      {
        selectedSeats && selectedSeats.length !== 0 && (
          <>
            {
              selectedSeats.map((item) => (
                item.numSelected ?
                  <DescriptionText>{item.seatId} - {item.numSelected}</DescriptionText>
                :<DescriptionText>{item.seatId}</DescriptionText>
              ))
            }
          </>
        )
      }
      <H2Text>
        Amount Payable
      </H2Text>
      <DescriptionText fontSize="24px">
        {payment ? `${currencyformatter((payment && (payment?.amount / 100.0)), payment?.currency.name)}` : null }
      </DescriptionText>
    </SmallScreenHeader>
  )
};

export default Header;
